module.exports = __webpack_public_path__ + "static/media/coach-joanie.2889dfe8.png";